<template>
   <div class="col-12 col-lg-12 mb-2" v-show="travaContinuar == pergunta.tela">
      <div class="row">
         <div class="col-12" v-show="pergunta.tipo == 'Dissertativa'">
            <label><i class="fas fa-keyboard color-theme mr-1 mt-3"></i><span class="font-15"> {{pergunta.pergunta}} </span></label>
            <input type="text" placeholder="Digite" class="form-control required rounded" maxlength="200" v-model="pergunta.descricao" />
         </div>
         <div class="col-12" v-show="pergunta.tipo == 'Alternativa'">
            <label><i class="fas fa-list color-theme mr-1 mt-3"></i><span class="font-15"> {{pergunta.pergunta}} </span></label>
            <v-select title="Desktop" class="rounded" :options="pergunta.listaAlternativa" v-model="pergunta.resposta" label="alternativa" />
            <select title="Mobile" class="form-control rounded" v-model="pergunta.resposta"> 
               <option v-for="(option, index) in pergunta.listaAlternativa" :key="index" :value="option">{{ option.alternativa }}</option>
            </select>
            <input type="text" class="form-control mt-1 rounded" maxlength="200" v-model="pergunta.descricao" placeholder="Texto opcional" 
               v-show="pergunta.resposta != null && pergunta.resposta != '' && pergunta.listaAlternativa.filter(p => p.id == pergunta.resposta.id)[0] != null && String(pergunta.listaAlternativa.filter(p => p.id == pergunta.resposta.id)[0].habilitaDescritiva) == 'true'" />    
         </div>
      </div>
   </div>
</template>

<script>

export default {
	name: 'Pergunta',
   props: ['pergunta', 'index', 'travaContinuar'],
}

</script>